import { ALLOWED_RECENT_LIMITS } from './listingsRecentLimit';
import { ALLOWED_DOCUMENT_STATUS_FILTERS } from '../../../helpers/listingDocumentStatusFilter';

export { ALLOWED_DOCUMENT_STATUS_FILTERS };

export function parseDocumentStatusFromUrl() {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  const value = params.get('documentStatus');
  if (value && ALLOWED_DOCUMENT_STATUS_FILTERS.includes(value)) {
    return value;
  }
  return null;
}

export function buildListingsQueryString({ recentLimit, documentStatusFilter }) {
  const params = new URLSearchParams();
  if (recentLimit && ALLOWED_RECENT_LIMITS.includes(recentLimit)) {
    params.set('recentLimit', String(recentLimit));
  }
  if (documentStatusFilter && ALLOWED_DOCUMENT_STATUS_FILTERS.includes(documentStatusFilter)) {
    params.set('documentStatus', documentStatusFilter);
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}
